import { keepPreviousData } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { useGetV4AdvReportByAd } from "./v4AdvReportByAd";

type Params = {
  adId: string | number;
  filters?: ColumnFiltersState;
  search?: string;
};

type Options = {
  enabled?: boolean;
};

export const useAdPlanDetails = ({ adId, filters = [], search }: Params, { enabled = true }: Options = {}) => {
  const adByAdOptionsGetter = useGetV4AdvReportByAd();
  const numericAdId = Number(adId);

  return {
    ...adByAdOptionsGetter({
      pagination: {
        pageIndex: 0,
        pageSize: 1,
      },
      sorting: [],
      filters: [
        {
          id: "ad_id",
          value: { op: "=", value: numericAdId },
        },
        ...filters,
      ],
      search,
    }),
    enabled,
    placeholderData: keepPreviousData,
  };
};
